import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store/store";
import { hideAlert } from "../../store/alertSlice";

const Alert: React.FC = () => {
  const dispatch = useDispatch();
  const { message, type, visible, size } = useSelector(
    (state: RootState) => state.alert
  );

  useEffect(() => {
    if (visible) {
      const timer = setTimeout(() => {
        dispatch(hideAlert());
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [visible, dispatch]);

  if (!visible) return null;

  return (
    <aui-alert type={type} size={size} onClick={() => dispatch(hideAlert())}>
      <strong className="aui-alert-txt" id="alert">
        {message}
      </strong>
    </aui-alert>
  );
};

export default Alert;
